import { createIntl, createIntlCache } from "react-intl";
import messages from "./index";

const cache = createIntlCache();

export const defaultLocale = "en";
export const locale = "en";

const intl = () =>
  createIntl(
    {
      locale: locale || defaultLocale,
      messages: messages[locale] || messages[defaultLocale],
    },
    cache
  );

export default intl;
